import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import Card from '@material-ui/core/Card'
import clsx from 'clsx'
import InfoIcon from '@material-ui/icons/Info'

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#f74872',
    alignItems: 'center',
  },
  Info: {
    color: 'red',
    width: '25px',
    height: '25px',
  },
  icon: {
    color: '#f74872',
    marginRight: ' 12px!important',
  },
}))

const useDangerStyle = makeStyles((theme) => ({
  root: {
    color: '#f74872',
    alignItems: 'center',
    boxShadow: 'none!important',
    backgroundColor: 'rgb(253, 236, 234)',
    display: 'flex',
  },
  icon: {
    color: '#f74872',
    marginRight: ' 12px!important',
  },
  Info: {
    color: 'red',
    width: '25px',
    height: '25px',
  },
}))

export const WarningDangerPanel = (props) => {
  const classes = useDangerStyle()
  return (
    <Card
      className={clsx('flex mb-24 p-5', classes.root)}
      style={{ background: 'rgba(247, 72, 114, 0.13)' }}
    >
      <InfoIcon className={classes.icon} />
      <Typography className="text-watermelon">{props.children}</Typography>
    </Card>
  )
}

export default ({ children }) => {
  const classes = useStyles()

  return (
    <Card
      className={clsx('flex items-center mx-4 mb-24 p-5', classes.root)}
      style={{ background: 'rgba(247, 72, 114, 0.13)' }}
    >
      <InfoIcon className={classes.icon} />
      <div className="w-full">{children}</div>
    </Card>
  )
}
